import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass(['toolbar-item-container-h5-title'])
}

import vue from '../../../../adapter-vue';
import { outsideClick } from '@tencentcloud/universal-api';
import Icon from '../../../common/Icon.vue';
import BottomPopup from '../../../common/BottomPopup/index.vue';
import { isPC, isH5 } from '../../../../utils/env';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  iconFile: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  needDialog: {
    type: Boolean,
    default: true,
  },
  iconWidth: {
    type: String,
    default: '20px',
  },
  iconHeight: {
    type: String,
    default: '20px',
  },
  // Whether to display the bottom popup dialog on mobile devices
  // Invalid on PC
  needBottomPopup: {
    type: Boolean,
    default: false,
  },
  isH5EmojiShow:{
    type:Boolean,
    default:false
  },
  isH5Emoji:{
    type:Boolean,
    default:false,
  },
  isH5ToolShow : {
    type:Boolean,
    default:false,
  }
},
  emits: ['onIconClick', 'onDialogClose', 'onDialogShow'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { ref } = vue;

const props = __props;

const emits = __emit;

const showDialog = ref(false);
const toolbarItemRef = ref();
const dialogRef = ref();
const toggleToolbarItem = () => {
  emits('onIconClick', dialogRef);
  if (isPC) {
    outsideClick.listen({
      domRefs: toolbarItemRef.value,
      handler: closeToolbarItem,
    });
  }
  if (!props.needDialog) {
    return;
  }
  toggleDialogDisplay(!showDialog.value);
};

const closeToolbarItem = () => {
  showDialog.value = false;
  emits('onDialogClose', dialogRef);
};

const toggleDialogDisplay = (showStatus: boolean) => {
  if (showDialog.value === showStatus) {
    return;
  }
  showDialog.value = showStatus;
  switch (showStatus) {
    case true:
      emits('onDialogShow', dialogRef);
      break;
    case false:
      emits('onDialogClose', dialogRef);
  }
};

const onPopupClose = () => {
  showDialog.value = false;
};

__expose({
  toggleDialogDisplay,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "toolbarItemRef",
    ref: toolbarItemRef,
    class: _normalizeClass([
      'toolbar-item-container',
      !_unref(isPC) && 'toolbar-item-container-h5',
    ])
  }, [
    (_unref(isPC) || (_unref(isH5) && !__props.isH5Emoji && __props.isH5ToolShow))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'toolbar-item-container-icon',
        _unref(isH5) && 'toolbar-item-container-h5-icon'
      ]),
          onClick: toggleToolbarItem
        }, [
          _createVNode(Icon, {
            file: props.iconFile,
            class: "icon",
            width: props.iconWidth,
            height: props.iconHeight
          }, null, 8, ["file", "width", "height"])
        ], 2))
      : _createCommentVNode("", true),
    ((_unref(isH5) && !__props.isH5Emoji && __props.isH5ToolShow))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.title), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      ref_key: "dialogRef",
      ref: dialogRef,
      class: _normalizeClass([
        'toolbar-item-container-dialog',
        !_unref(isPC) && 'toolbar-item-container-h5-dialog',
      ])
    }, [
      (props.needBottomPopup && !_unref(isPC))
        ? (_openBlock(), _createBlock(BottomPopup, {
            key: 0,
            class: "toolbar-bottom-popup",
            show: _unref(showDialog) || __props.isH5EmojiShow,
            onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
            onOnClose: onPopupClose
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["show"]))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ], 2), [
      [_vShow, _unref(showDialog) || __props.isH5EmojiShow]
    ])
  ], 2))
}
}

})